import { createI18n } from 'vue-i18n'
import messages from 'src/i18n'

export default ({ app }) => {

  const getBrowserLocale = () => {
    const savedLang = localStorage.getItem('user-lang') // Check if user set a language
    if (savedLang) return savedLang

    const browserLang = navigator.language || navigator.userLanguage || 'en-US' // Default to English
    return browserLang
  }

  // Create I18n instance
  const i18n = createI18n({
    legacy: false,
    locale: getBrowserLocale(),
    globalInjection: true,
    messages,
    pluralRules: {
      'en-US': 'n == 1 ? 0 : 1',
    },
    fallbackLocale: 'en-US',
    missingWarn: false,
    fallbackWarn: false,
  })

  // Tell app to use the I18n instance
  app.use(i18n)
}
